class MatchAddShotsIndividualController {
  constructor(MatchesFactory, LeaguesFactory, $rootScope, $filter, $state) {
    "ngInject";
    const vm = this;

    let $translate = $filter("translate");

    vm.rootScope = $rootScope;
    vm.$onInit = () => {
      $state.current.data.hideSidebar = true;
      $state.current.data.hideMatchProfile = true;
      $state.current.data.hideMatchMenu = true;
      vm.leagues = [];
      vm.activeLeague = null;
      vm.roundsTemplate = ["1/32", "1/16", "1/8", "1/4", "1/2", "1/1"];
      vm.rounds = [];
      vm.activeRound = null;
      vm.activeEliminationMatches = [];
      vm.activeEliminationMatch = null;
      vm.roundOneShots = {};
      vm.roundTwoShots = {};
      vm.shotsHeaders = [
        { name: "#", class: "col-xs-1" },
        { name: "1ο", class: "col-xs-1" },
        { name: "2ο", class: "col-xs-1" },
        { name: "3ο", class: "col-xs-1" },
        { name: "Shot", class: "col-xs-1" },
        { name: "Score", class: "col-xs-1" },
        { name: "#", class: "col-xs-1" },
        { name: "1ο", class: "col-xs-1" },
        { name: "2ο", class: "col-xs-1" },
        { name: "3ο", class: "col-xs-1" },
        { name: "Shot", class: "col-xs-1" },
        { name: "Score", class: "col-xs-1" },
      ];
      vm.maxShots = 6;
      vm.moveToNextTarget = false;
      /* Fetch Leagues with Individual Matches */
      MatchesFactory.getOne(vm.rootScope.currentMatchId, {
        include: "matchLeagues",
      }).then((response) => {
        Object.entries(response.data.matchLeagues).forEach((entry) => {
          let value = entry[1];
          if (value.olympic_players && value.olympic_players > 0) {
            value.league.currentIndividualRound = value.currentIndividualRound;
            vm.leagues.push(value.league);
          }
        });
      });
    };

    vm.isLeagueCompound = () => {
      return vm.activeLeague.type === LeaguesFactory.LEAGUE_TYPES.COMPOUND;
    };

    vm.isLeagueRecurve = () => {
      return vm.activeLeague.type === LeaguesFactory.LEAGUE_TYPES.RECURVE;
    };

    vm.isLeagueField = () => {
      return vm.activeLeague.type === LeaguesFactory.LEAGUE_TYPES.FIELD;
    };

    vm.selectLeague = (league) => {
      vm.activeLeague = league;
      vm.rounds = [];
      vm.rounds = vm.roundsTemplate;
      vm.activeRound = league.currentIndividualRound;
      vm.activeEliminationMatch = null;
      // let found = false;
      // for(let i = 0; i < vm.roundsTemplate; i++){
      // if(found || vm.roundsTemplate[i] === vm.activeLeague.currentIndividualRound){
      // 	found = true;
      // 	vm.rounds.push(vm.roundsTemplate[i]);
      // }
      // }
      reloadLeagueEliminationMatches(false);
    };
    vm.selectRound = (round) => {
      vm.activeRound = round;
      reloadLeagueEliminationMatches();
    };
    vm.refresh = () => {
      reloadLeagueEliminationMatches(true);
    };
    vm.goToVisual = () => {
      window.open(
        `/match-profile/shotsIndividualVisual/${vm.rootScope.currentMatchId}/${vm.activeLeague.league_id}/${vm.activeEliminationMatch.olympic_match_id}`,
        "_blank"
      );
    };
    vm.selectEliminationMatch = (eliminationMatchId) => {
      vm.activeEliminationMatch = vm.eliminationMatches.find(
        (eliminationMatch) => {
          return eliminationMatch.olympic_match_id === eliminationMatchId;
        }
      );
      vm.roundOneShots = {};
      vm.roundTwoShots = {};
      vm.roundOneFinalShot = null;
      vm.roundTwoFinalShot = null;
      vm.roundOneFinalShotTwo = null;
      vm.roundTwoFinalShotTwo = null;
      vm.roundOneCloseToCenter = null;
      vm.roundTwoCloseToCenter = null;
      vm.activeRoundOne = vm.activeEliminationMatch.rounds[0];
      vm.activeRoundTwo = vm.activeEliminationMatch.rounds[1];
      if (vm.isLeagueCompound()) {
        if (
          vm.activeRoundOne.points === "bye" ||
          vm.activeRoundTwo.points === "bye"
        ) {
          vm.activeRoundOne.displayScore = vm.activeRoundOne.points;
          vm.activeRoundTwo.displayScore = vm.activeRoundTwo.points;
        } else {
          vm.activeRoundOne.displayScore = parseInt(vm.activeRoundOne.points);
          vm.activeRoundTwo.displayScore = parseInt(vm.activeRoundTwo.points);
          if (vm.activeRoundOne.arrow_f) {
            vm.activeRoundOne.displayScore += parseInt(
              vm.activeRoundOne.arrow_f
            );
          }
          if (vm.activeRoundTwo.arrow_f) {
            vm.activeRoundTwo.displayScore += parseInt(
              vm.activeRoundTwo.arrow_f
            );
          }
        }
      } else {
        vm.activeRoundOne.displayScore = vm.activeRoundOne.points;
        vm.activeRoundTwo.displayScore = vm.activeRoundTwo.points;
      }
      for (let i = 1; i < vm.maxShots; i++) {
        vm.roundOneShots[i] = {
          arrows: {
            1: vm.activeRoundOne["arrow_" + i + "_1"],
            2: vm.activeRoundOne["arrow_" + i + "_2"],
            3: vm.activeRoundOne["arrow_" + i + "_3"],
          },
          stats: {
            endScore: 0,
            score: 0,
          },
        };
        vm.roundTwoShots[i] = {
          arrows: {
            1: vm.activeRoundTwo["arrow_" + i + "_1"],
            2: vm.activeRoundTwo["arrow_" + i + "_2"],
            3: vm.activeRoundTwo["arrow_" + i + "_3"],
          },
          stats: {
            endScore: 0,
            score: 0,
          },
        };
      }
      vm.roundOneFinalShot = vm.activeRoundOne["arrow_f"];
      vm.roundTwoFinalShot = vm.activeRoundTwo["arrow_f"];
      vm.roundOneFinalShotTwo = vm.activeRoundOne["arrow_f_2"];
      vm.roundTwoFinalShotTwo = vm.activeRoundTwo["arrow_f_2"];
      vm.roundOneCloseToCenter = vm.activeRoundOne["closer_to_center"] === 1;
      vm.roundTwoCloseToCenter = vm.activeRoundTwo["closer_to_center"] === 1;
      vm.calculateArrows();
    };
    vm.addShots = () => {
      let roundOneShots = {};
      let roundTwoShots = {};
      for (let i = 1; i < vm.maxShots; i++) {
        roundOneShots[i] = vm.roundOneShots[i].arrows;
        roundTwoShots[i] = vm.roundTwoShots[i].arrows;
      }
      let roundOneId = vm.activeRoundOne.olympic_round_id;
      let roundTwoId = vm.activeRoundTwo.olympic_round_id;
      let rounds = [
        {
          roundId: roundOneId,
          shots: roundOneShots,
        },
        {
          roundId: roundTwoId,
          shots: roundTwoShots,
        },
      ];
      let finalShots = [
        {
          roundId: roundOneId,
          shot: vm.roundOneFinalShot,
          shot_2: vm.roundOneFinalShotTwo,
          closer_to_center: vm.roundOneCloseToCenter,
        },
        {
          roundId: roundTwoId,
          shot: vm.roundTwoFinalShot,
          shot_2: vm.roundTwoFinalShotTwo,
          closer_to_center: vm.roundTwoCloseToCenter,
        },
      ];
      MatchesFactory.addShotsElimination(
        vm.activeEliminationMatch.olympic_match_id,
        MatchesFactory.MATCH_ELIMINATION_TYPES.INDIVIDUAL,
        {
          rounds: rounds,
          finalShots: finalShots,
        }
      ).then((response) => {
        reloadLeagueEliminationMatches();
      });
    };
    vm.clearRoundShots = () => {
      MatchesFactory.clearShotsElimination(
        vm.activeEliminationMatch.olympic_match_id,
        MatchesFactory.MATCH_ELIMINATION_TYPES.INDIVIDUAL
      ).then((response) => {
        reloadLeagueEliminationMatches();
      });
    };
    vm.calculateArrows = () => {
      vm.roundOneScore = 0;
      vm.roundTwoScore = 0;
      for (let i = 1; i < 4; i++) {
        vm.roundOneShots[i].stats.score = 0;
        vm.roundTwoShots[i].stats.score = 0;
      }
      for (let i = 1; i <= vm.maxShots; i++) {
        let shotOneScore = 0;
        let shotTwoScore = 0;
        if (i === vm.maxShots) {
          shotOneScore = parseInt(vm.roundOneFinalShot);
          shotTwoScore = parseInt(vm.roundTwoFinalShot);
        } else {
          for (let j = 1; j < 4; j++) {
            if (!vm.roundOneShots[i].arrows[j]) {
              continue;
            }

            /* Round One */
            if (vm.roundOneShots[i].arrows[j] == 0) {
              vm.roundOneShots[i].arrows[j] = "m";
            }
            if (vm.roundOneShots[i].arrows[j].toLowerCase() !== "m") {
              shotOneScore =
                shotOneScore + parseInt(vm.roundOneShots[i].arrows[j]);
            }
            /* Round Two */
            if (!vm.roundTwoShots[i].arrows[j]) {
              continue;
            }
            if (vm.roundTwoShots[i].arrows[j] == 0) {
              vm.roundTwoShots[i].arrows[j] = "m";
            }
            if (vm.roundTwoShots[i].arrows[j].toLowerCase() !== "m") {
              shotTwoScore =
                shotTwoScore + parseInt(vm.roundTwoShots[i].arrows[j]);
            }
          }
          vm.roundOneShots[i].stats.endScore = shotOneScore;
          vm.roundTwoShots[i].stats.endScore = shotTwoScore;
          if (!vm.roundOneShots[i].arrows[3]) {
            continue;
          }
          if (!vm.roundTwoShots[i].arrows[3]) {
            continue;
          }
        }
        /* RECURVE SCORING */
        if (vm.isLeagueRecurve() || vm.isLeagueField()) {
          // if(vm.activeLeague.type === LeaguesFactory.LEAGUE_TYPES.RECURVE){
          /* iF shoot off */
          if (i === vm.maxShots) {
            if (vm.roundOneFinalShot && vm.roundTwoFinalShot) {
              if (shotOneScore > shotTwoScore) {
                vm.roundOneScore += 2;
              } else if (shotOneScore < shotTwoScore) {
                vm.roundTwoScore += 2;
              }
            }
          } else {
            if (shotOneScore > shotTwoScore) {
              vm.roundOneShots[i].stats.score = 2;
              vm.roundOneScore += 2;
            } else if (shotOneScore < shotTwoScore) {
              vm.roundTwoShots[i].stats.score = 2;
              vm.roundTwoScore += 2;
            } else if (shotOneScore && shotTwoScore) {
              vm.roundOneShots[i].stats.score = 1;
              vm.roundOneScore++;
              vm.roundTwoShots[i].stats.score = 1;
              vm.roundTwoScore++;
            }
          }
        } else {
          /* COMPOUND SCORING */
          /* iF shoot off */
          if (i === vm.maxShots) {
            if (vm.roundOneFinalShot && vm.roundTwoFinalShot) {
              vm.roundOneScore += shotOneScore;
              vm.roundTwoScore += shotTwoScore;
            }
          } else {
            vm.roundOneScore += shotOneScore;
            vm.roundOneShots[i].stats.score = vm.roundOneScore;
            vm.roundTwoScore += shotTwoScore;
            vm.roundTwoShots[i].stats.score = vm.roundTwoScore;
          }
        }
      }
    };
    vm.forfeited = (player) => {
      MatchesFactory.forfeitElimination(
        vm.activeEliminationMatch.olympic_match_id,
        MatchesFactory.MATCH_ELIMINATION_TYPES.INDIVIDUAL,
        player.player_id
      ).then((response) => {
        reloadLeagueEliminationMatches();
      });
    };

    function reloadLeagueEliminationMatches(reloadActiveMatch = true) {
      let data = {
        include: "matchOlympicIndividual",
        league_id: vm.activeLeague.league_id,
        round: vm.activeRound,
      };
      vm.eliminationMatches = [];
      MatchesFactory.getOne(vm.rootScope.currentMatchId, data).then(
        (response) => {
          vm.eliminationMatches = response.data.matchOlympicIndividual;
          if (vm.activeEliminationMatch && reloadActiveMatch) {
            let activeEliminationMatchId =
              vm.activeEliminationMatch.olympic_match_id;
            vm.activeEliminationMatch = null;
            vm.selectEliminationMatch(activeEliminationMatchId);
          }
        }
      );
    }
  }
}

export default MatchAddShotsIndividualController;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchProfile/matchAddShotsIndividual/matchAddShotsIndividual.controller.js